'use strict';

exports = module.exports = require('./lib/memoizer')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ./~/intl-format-cache/index.js
// module id = 395
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 16 17